export enum CodeTableNumber {
  CODE_TABLE_NAMES = 1,
  USER_GROUPS = 2,
  ENTITY_TYPES = 3,
  CUSTOM_COST_TYPES = 4,
  PROPERTY_TYPES = 5,
  PROPERTY_TYPES_EX = 6,
  PROJECT_TYPE = 7,
  BUSINESS_TYPES = 8,
  PROJECT_METHOD = 9,
  WAIVER_DESCRIPTION = 10,
  REPORT_TAGS = 11,
}
